import { render, staticRenderFns } from "./ParcelleCard.vue?vue&type=template&id=11661f6d"
import script from "./ParcelleCard.vue?vue&type=script&lang=js"
export * from "./ParcelleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports